var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_794_6",
    "data-name": "Component 794 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50831",
    "data-name": "Path 50831",
    d: "M183.292-767.213a10.133,10.133,0,0,1-6.884-2.565A9.892,9.892,0,0,1,173-776.257h.945a9.584,9.584,0,0,0,3.189,5.787,9,9,0,0,0,6.159,2.312,9.116,9.116,0,0,0,6.7-2.75,9.116,9.116,0,0,0,2.75-6.7,9.116,9.116,0,0,0-2.75-6.7,9.116,9.116,0,0,0-6.7-2.75,8.979,8.979,0,0,0-3.813.827,10.771,10.771,0,0,0-3.206,2.278h3.24v.945h-4.859v-4.859h.945v3.24a11.13,11.13,0,0,1,3.51-2.48,10.1,10.1,0,0,1,4.184-.894,10.17,10.17,0,0,1,4.049.81,10.449,10.449,0,0,1,3.307,2.227,10.449,10.449,0,0,1,2.227,3.307,10.17,10.17,0,0,1,.81,4.049,10.17,10.17,0,0,1-.81,4.049,10.448,10.448,0,0,1-2.227,3.307,10.449,10.449,0,0,1-3.307,2.227A10.169,10.169,0,0,1,183.292-767.213Zm4.488-5.332-4.859-4.859v-6.952h.945v6.547l4.589,4.589Z",
    transform: "translate(-163 798)",
    fill: "#707070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16239",
    "data-name": "Rectangle 16239",
    width: 40,
    height: 40,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.ca288c7e8c6f5a014c8e1988e02175b2.svg";
export { ForwardRef as ReactComponent };